var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { htmlToPdf } from './signoAPI';
import { performAxiosRequest } from './requestHelper';
import { log } from '../utils/logger';
export const htmlBase64ToPdf = (html) => __awaiter(void 0, void 0, void 0, function* () {
    return performAxiosRequest(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield htmlToPdf(html);
        log.debug('[Form service] POST all form responses - response.status ==> ', response.status);
        log.debug('[Form service] PDF base64 string length ==> ', response.data.length);
        return response.data; // 👈 Aquí retornas el base64 real del PDF
    }));
});
export const encodeUnicodeToBase64 = (text) => {
    // Convertir a UTF-8 antes de codificar
    const utf8Bytes = new TextEncoder().encode(text);
    if (typeof window !== 'undefined') {
        // Para navegador, convertir UTF-8 bytes a string y luego codificar
        let binaryString = '';
        utf8Bytes.forEach((byte) => {
            binaryString += String.fromCharCode(byte);
        });
        return window.btoa(binaryString);
    }
    else if (typeof Buffer !== 'undefined') {
        // Para Node.js
        return Buffer.from(text).toString('base64');
    }
    else {
        throw new Error('No se pudo encontrar un método de codificación Base64 disponible');
    }
};
export const descargarPDFBase64 = (base64Data, nombreArchivo = 'documento.pdf') => {
    try {
        if (!base64Data || typeof base64Data !== 'string') {
            console.error('Base64 inválido o vacío');
            return;
        }
        // Limpiar posibles prefijos como data:application/pdf;base64,
        const base64Clean = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;
        // Convertir a binario
        const byteCharacters = atob(base64Clean);
        const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        // Crear el link para descarga
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = nombreArchivo;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        // Limpieza
        setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }, 100);
    }
    catch (error) {
        console.error('Error al convertir base64 a PDF:', error);
    }
};
